import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import HappyGoStayKeyIcon from '@stencil/icons/src/HappyGoStayKeyIcon/HappyGoStayKeyIcon';
import HappyGoStayLogoNew from '@stencil/icons/src/HappyGoStayLogoNew/HappyGoStayLogoNew';
import useIsClient from '@stencil/hotels-hooks/src/useIsClient';

import {detailsPagePushGaThunk} from '@stencil/hotels-ga/src';
import {gaConfig} from '@stencil/hotels-config';

import * as S from './GoStaysTag.styles';
import {
  CenteredSpaceWrap,
  PrimaryLink,
} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

// Omniture Imports
import {omnitureThunk, omnitureConfig} from '@stencil/omniture-analytics/src';
import {
  detailsClick,
  DetailsPageComponents,
} from '@stencil/omniture-analytics/src/constants/details';

const {DetailsGAClickEventActions} = gaConfig;

const goStayData = [
  // {
  //   text: 'Trip Insurance',
  //   isFree: true,
  // },
  {
    text: '100% Money Back Guarantee*',
  },
  {
    text: 'Hassle-Free Check-in',
  },
];

type GoStayTagPersuasionType = {
  defaultOpen?: boolean;
  onCtaClick?: Function;
  positionTop?: boolean;
  forDetailsPage?: boolean;
  margin?: any;
  ctaText?: string;
  onCrossClick?: Function;
};

const GoStaysTag = ({
  defaultOpen = false,
  onCtaClick = () => {},
  positionTop = false,
  ctaText = 'Show Gostay Properties',
  margin,
  forDetailsPage = false,
  onCrossClick = () => {},
}: GoStayTagPersuasionType) => {
  const [open = defaultOpen, setOpen] = useState();
  const isClient = useIsClient();
  const dispatch = useDispatch();

  const ctaClickHandler = (e: any) => {
    e.stopPropagation();
    onCtaClick({tag: 'goStays'});
  };

  const onCrossClickHandler = e => {
    e.stopPropagation();
    setOpen(false);
    onCrossClick();
  };

  if (!isClient) return null;

  return (
    <S.GoStaysTagContainer
      onMouseEnter={() => !defaultOpen && setOpen(true)}
      onMouseLeave={() => !defaultOpen && setOpen(false)}
      forDetailsPage={forDetailsPage}
      margin={margin}
    >
      {forDetailsPage ? (
        <>
          <HappyGoStayLogoNew width="67px" height="18px" margin="2px 8px 0 0" />
          <S.CertifiedGoStaysText>Top Rated Affordable Properties</S.CertifiedGoStaysText>
          <S.CertifiedGoStarsImg alt="star" src="https://gos3.ibcdn.com/g2-1657711763.png" />
          <S.ArrowIconWrapper></S.ArrowIconWrapper>
        </>
      ) : (
        <HappyGoStayKeyIcon />
      )}

      {open && (
        <S.GoStaysTagDropDownOuter forDetailsPage={forDetailsPage}>
          <S.TipPositioning positionTop={positionTop} />
          <S.GoStaysDropDownHover>
            {defaultOpen && <a className="close" onClick={onCrossClickHandler}></a>}
            <S.GoStaysImg
              alt="goStays"
              src="https://gos3.ibcdn.com/srp_main_filter_gstay-1658329023.png"
            />
            <CenteredSpaceWrap>
              <ul>
                {goStayData.map((item, idx) => {
                  return (
                    <S.GoStaysDropDownItem>
                      <S.TickIconWrap />
                      <S.GoStaysDropDownItemText>{item.text}</S.GoStaysDropDownItemText>
                      {item.isFree && <S.FreeTag>Free</S.FreeTag>}
                    </S.GoStaysDropDownItem>
                  );
                })}
              </ul>
            </CenteredSpaceWrap>
            {forDetailsPage ? (
              <S.GoStaysShowPropertyCta
                href="https://www.goibibo.com/offers/gostays-learnmore/"
                target="_blank"
                rel="noopener"
                onClick={() => {
                  dispatch(
                    detailsPagePushGaThunk({
                      eventAction: DetailsGAClickEventActions.gostaysKnowMoreClick,
                    }),
                  );
                  dispatch(
                    omnitureThunk(omnitureConfig.pages.Details, omnitureConfig.events.ctaClick, {
                      cta: {
                        name: `${DetailsPageComponents.GoStaysTag}_${detailsClick.goStaysTag.gostaysKnowMoreClick}`,
                        type: omnitureConfig.ctaType.Hyperlink,
                        componentName: DetailsPageComponents.GoStaysTag,
                        destination: 'https://www.goibibo.com/offers/gostays-learnmore/',
                      },
                    }),
                  );
                }}
              >
                Learn More
              </S.GoStaysShowPropertyCta>
            ) : (
              <S.GoStaysShowPropertyCta onClick={ctaClickHandler}>
                {ctaText}
              </S.GoStaysShowPropertyCta>
            )}
          </S.GoStaysDropDownHover>
        </S.GoStaysTagDropDownOuter>
      )}
    </S.GoStaysTagContainer>
  );
};

export default GoStaysTag;
